import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';
import { ListItemAvatar, ListItemText } from './List';
import GoalTypeIcon from './GoalTypeIcon';
import { TriggerType } from '../../domain/entity/Goal';

interface IProps {
  id: string;
  title: string;
  type: TriggerType;
}

const GoalItem = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const GoalItemText = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const GoalItemId = styled.span`
  display: inline-block;
  margin-right: 1em;
  font-size: 0.923rem;
  color: ${colors.ash__b4bed5};
  line-height: 1;
`;

const GoalItemTitle = styled.span`
  display: inline-block;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 2em;
  text-align: left;
  line-height: 1;
`;

export class GoalListItem extends React.PureComponent<IProps, {}> {
  public render() {
    const { id, title, type } = this.props;
    return (
      <GoalItem>
        <ListItemAvatar>
          <GoalTypeIcon type={type} size={30} />
        </ListItemAvatar>
        <ListItemText>
          <GoalItemText>
            <GoalItemTitle>{title}</GoalItemTitle>
            <GoalItemId>#{id}</GoalItemId>
          </GoalItemText>
        </ListItemText>
      </GoalItem>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/GoalListItem.tsx